import { ReactNode } from 'react';
import { renderMultiListToTagsWithLink } from '@ohpen/enso-ui';

type ReadonlyLinkedTagEntity = {
  value: unknown;
  [key: string]: unknown;
};

// Enso's readonlyDisplay 'tagsWithLink' maps over an array, so a field holding a single reference is wrapped in one.
export const renderReadonlyLinkedTag =
  (getPath: (id: string) => string) =>
  (dom: ReactNode | null, { value, ...rest }: ReadonlyLinkedTagEntity): ReactNode =>
    renderMultiListToTagsWithLink(dom, { ...rest, value: value ? [String(value)] : [] }, getPath);
